export const selectTheme = (state) => {
  return state.application?.signUp?.theme;
};
